import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0 w-full',
    wrapper: 'relative overflow-hidden',
    label:
      'text-secondary-hover peer-disabled:text-inactive absolute top-5 left-4 -z-10 origin-[0] -translate-y-5 scale-75 transform font-light whitespace-nowrap transition-all duration-200 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-5 peer-focus:scale-75',
    textarea:
      'peer focus:placeholder:text-secondary-hover disabled:placeholder:text-inactive disabled:text-inactive scrollbar-hidden mt-6 block !max-h-[70vh] w-full resize-none appearance-none border-0 border-b-1 border-black px-4 pb-3 font-light transition-colors duration-200 placeholder:text-transparent placeholder:opacity-0 placeholder:transition-colors placeholder:duration-200 focus:outline-none focus:placeholder:opacity-100',
    helperText: 'text-secondary-hover px-4 pt-1 text-sm font-light',
    count: 'heading-s absolute right-0 -bottom-7',
    required: 'ml-0.5'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-text-error',
        label: 'text-text-error',
        input: 'border-bg-delete-error'
      }
    }
  }
});
